<template>
  <div id="page_policy" data-role="page">
    <header class="pageHeader">
      <div class="pageHeader_img">
        <div class="content">
          <h2 class="pageHeader_title">反社会的勢力への対応に関する基本方針</h2>
        </div>
      </div>
    </header>
    <section class="policy">
      <div class="content">
        <p class="policy_lead">
          当社は、暴力、威力と詐欺的手法を駆使して経済的利益を追求する集団又は個人である「反社会的勢力」による被害を防止するために、次の基本方針を宣言します。
        </p>
        <ol class="policy_olist">
          <li>
            反社会的勢力からの被害防止の観点から、社内規程等に基づき、組織全体として対応を行うものとし、役職員の安全を確保します。
          </li>
          <li>
            反社会的勢力による被害を防止するために、警察・暴力追放推進センター・弁護士等の外部専門機関と緊密な連携をします。
          </li>
          <li>
            反社会的勢力とは取引関係を含めて一切の関係を持ちません。また、反社会的勢力による不当要求は拒絶します。
          </li>
          <li>
            反社会的勢力による不当要求に対しては、毅然として民事、刑事の両面からの法的対応を行います。
          </li>
          <li>
            当社は、いかなる時も裏取引を行いません。また、反社会的勢力への資金提供は絶対に行いません。
          </li>
        </ol>
      </div>
    </section>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  created: async function() {},
  mounted: async function() {},
  methods: {}
};
</script>
